import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Button } from '@sendible/design-system/src';
import { Container } from './index.styles';

const TAB_OPTIONS = [
  { label: 'tab_main', id: 'main' },
  { label: 'tab_scheduled', id: 'scheduled' },
  { label: 'tab_sent', id: 'sent' },
  { label: 'tab_failed', id: 'failed' },
];

export const TabNavBar = () => {
  const { t } = useTranslation('calendar');
  const [searchParams, setSearchParams] = useSearchParams();
  const viewParam = searchParams.get('view');
  const activeStatus = (['scheduled', 'sent', 'failed'] as const).includes(viewParam as never) ? (viewParam as string) : 'main';

  const handleTabClick = (id: string) => {
    setSearchParams({ ...Object.fromEntries(searchParams), view: id });
  };

  return (
    <Container role="tablist">
      {TAB_OPTIONS.map((option) => (
        <Button
          aria-selected={activeStatus === option.id}
          customClass={activeStatus === option.id ? 'active' : ''}
          key={option.id}
          label={t(option.label) as string}
          onClick={() => handleTabClick(option.id)}
          role="tab"
          size={12}
          variation={activeStatus === option.id ? 'fill' : 'default'}
        />
      ))}
    </Container>
  );
};
